import { createAsyncThunk } from '@reduxjs/toolkit'
import homeAPI from '../../../apis/api/api-home-setting'

export const getHomeSetting = createAsyncThunk('/HomePage/getHomeSetting', async () => {
  return await homeAPI.getHomeSetting()
})
